<template>
  <div>
    <div class="">
      <div class="banner">
        <div class="container">
          <div class="header-div">
            <h1 class="header-text">Gallery</h1>
            <img class="header-logo" src="../assets/images/logo.png" alt="Company Logo" />
          </div>
        </div>
      </div>
      <div>
        <div class="gallery-label">
          <span class="left"></span> OUR GALLERY <span class="right"></span>
        </div>
        <div class="gallery-container">
          <div class="gallery-grid">
            <div v-for="(img, idx) in galleryImages" :key="idx" class="gallery-item" @click="openLightbox(idx)">
              <img :src="img.src" :alt="img.alt" class="gallery-img" loading="lazy" />
              <div class="gallery-overlay">
                <span class="view-text">View</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="lightboxOpen" class="lightbox-overlay" @click="closeLightbox">
        <div class="lightbox-content" @click.stop>
          <button class="close-btn" @click="closeLightbox">&times;</button>
          <img :src="galleryImages[currentImageIndex].src" :alt="galleryImages[currentImageIndex].alt"
            class="lightbox-img" />
          <div class="lightbox-nav">
            <button class="nav-btn prev" @click="previousImage" :disabled="currentImageIndex === 0">
              &#8249;
            </button>
            <span class="image-counter">
              {{ currentImageIndex + 1 }} / {{ galleryImages.length }}
            </span>
            <button class="nav-btn next" @click="nextImage" :disabled="currentImageIndex === galleryImages.length - 1">
              &#8250;
            </button>
          </div>
        </div>
      </div>
      <div class="promo-banner-container">
        <div class="promo-banner">
          <div class="promo-content">
            <h1 class="promo-banner-title">10% Off All 2025 Lawn Mowing Services</h1>
            <p class="tagline">YOUR NEED. YOUR TIME. YOUR CHOICE</p>
            <p class="service-decs">Service just 2 clicks away</p>
            <p class="service-decs">Download the app now to lock in your discount.</p>
            <div class="app-buttons">
              <img src="../assets/images/apple-store-ligth.svg" alt="Download on App Store" />
              <img src="../assets/images/playstore-ligth.svg" alt="Get it on Google Play" />
            </div>
          </div>
          <div class="phone-mockup">
            <img class="" src="../assets/images/splash-mockup.svg" alt="Phone Mockup" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import g1 from '../assets/images/gallery/g1.jpeg';
import g2 from '../assets/images/gallery/g2.jpeg';
import g3 from '../assets/images/gallery/g3.svg';
import g4 from '../assets/images/gallery/g4.jpeg';
import g5 from '../assets/images/gallery/g5.svg';
import g6 from '../assets/images/gallery/g6.jpeg';
import g7 from '../assets/images/gallery/g9.svg';
import g12 from '../assets/images/gallery/g12.jpeg';
import g13 from '../assets/images/gallery/g13.jpeg';
import g14 from '../assets/images/gallery/g14.jpeg';
import g15 from '../assets/images/gallery/g15.jpeg';
import g16 from '../assets/images/gallery/g16.jpeg';
import g17 from '../assets/images/gallery/g17.jpeg';
import g18 from '../assets/images/gallery/g18.jpeg';
import g19 from '../assets/images/gallery/g19.jpeg';


import "react-photo-album/styles.css";

export default {
  data() {
    return {
      galleryImages: [
        // { src: g1, alt: 'Modern House with Landscaping' },
        // { src: g2, alt: 'Luxury Home Exterior' },
        { src: g3, alt: 'Contemporary Architecture' },
        // { src: g4, alt: 'Beautiful Residential Property' },
        { src: g5, alt: 'Elegant Home Design' },
        // { src: g6, alt: 'Modern House with Landscaping' },
        { src: g7, alt: 'Luxury Home Exterior' },
        { src: g12, alt: 'Contemporary Architecture' },
        { src: g13, alt: 'Beautiful Residential Property' },
        { src: g14, alt: 'Elegant Home Design' },
        { src: g15, alt: 'Elegant Home Design' },
        { src: g16, alt: 'Elegant Home Design' },
        { src: g17, alt: 'Elegant Home Design' },
        { src: g18, alt: 'Elegant Home Design' },
        { src: g19, alt: 'Elegant Home Design' },
      ],
      lightboxOpen: false,
      currentImageIndex: 0
    };
  },
  methods: {
    openLightbox(index) {
      this.currentImageIndex = index;
      this.lightboxOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeLightbox() {
      this.lightboxOpen = false;
      document.body.style.overflow = 'auto';
    },
    nextImage() {
      if (this.currentImageIndex < this.galleryImages.length - 1) {
        this.currentImageIndex++;
      }
    },
    previousImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
      }
    }
  },
  beforeUnmount() {
    // Clean up in case component is destroyed while lightbox is open
    document.body.style.overflow = 'auto';
  }
};
</script>

<style scoped lang="scss">
  @use '@/assets/styles/components/gallery';
</style>